export default theme => ({
  warningColor: {
    color: theme.palette.warning.main,
    verticalAlign: 'middle'
  },
});

